import React from 'react';
import {Button, styled, Typography} from "@mui/material";
import type {TabConfig} from "../../../types";

// region TypeScript Interfaces
type CatalogTabProps = TabConfig;
// endregion

const Tab = styled(Button)(({theme, selected}: any) => ({
    width: "324px",
    height: "100%",
    padding: "12px 20px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    border: selected ? `2px solid ${theme.palette.tertiary.main}` : "1px solid #DCDCDC",
    borderRadius: "4px",
    backgroundColor: "white",
    "&:hover": {
        backgroundColor: "#f5f5f5",
        borderColor: selected ? theme.palette.tertiary.main : "#DCDCDC",
    },
}));

const TabTitle = styled(Typography)(({theme, selected}: any) => ({
    flex: 1,
    textTransform: "none",
    fontSize: "14px",
    fontWeight: "600",
    color: selected ? theme.palette.tertiary.main : "#7B7B7B",
}));

const TabDescription = styled(Typography)(({theme, selected}: any) => ({
    flex: 1,
    textTransform: "none",
    fontSize: "12px",
    textAlign: "left",
    opacity: selected ? 1 : 0.5,
}));

function CatalogTab(props: CatalogTabProps) {
    return (
        <Tab onClick={props.onClick as any} {...({selected: props.selected ? 1 : 0} as any)} style={props.style}>
            <TabTitle {...({selected: props.selected ? 1 : 0} as any)}>
                {props.title}
            </TabTitle>

            <TabDescription {...({selected: props.selected ? 1 : 0} as any)}>
                {props.description}
            </TabDescription>
        </Tab>
    );
}

export default CatalogTab;
